import SvgComponent from "../../SVGComponent";

const PositiveNegativeButton = ({
  btnText,
  btnType,
  handleFunction,
  isDisabled,
  enabledTextColor,
  disabledTextColor,
  enabledBgColor,
  disabledBgColor,
  borderRadiusTopLeft,
  borderRadiusBottomRight,
  isLoading,
  icon,
  hoverOption,
  buttonRef,
  imgColor,

  // Account
  isApprovedAccount = false,
  imgColorAcccount,
  iconAccount,
  btnTextAccount,
  fullWidthRequired,
}) => {
  const hoverClass = isDisabled
    ? "not-allowed opacity-light-opacity"
    : `pointer ${
        hoverOption === "white" ? "global-hover-white" : "global-hover-black"
      }`;

  return (
    <button
      ref={buttonRef ? buttonRef : null}
      type={btnType !== null ? btnType : "button"}
      onClick={(e) => {
        if (!isLoading) handleFunction(e);
      }}
      className={`flex z-z-index-base relative justify-center items-center w-full h-auto p-padding-sm cursor-${hoverClass} ${
        borderRadiusTopLeft ? "rounded-tl-border-radius-md " : ""
      }${borderRadiusBottomRight ? "rounded-br-border-radius-md " : ""}${
        isApprovedAccount
          ? "w-topnav-large-btn-width"
          : "max-w-positive-negative-btn-width"
      }`}
      style={{
        backgroundColor:
          isDisabled && disabledBgColor
            ? disabledBgColor.toString()
            : enabledBgColor?.toString(),
      }}
    >
      {isApprovedAccount ? (
        <div
          className={`flex w-width-full h-height-full rounded-br-border-radius-md z-z-index-base relative flex-col items-center justify-center `}
        >
          <div className="mb-margin-button-s">
            {iconAccount ? (
              <SvgComponent
                color={imgColorAcccount}
                height="var(--icon-lg)"
                width="var(--icon-lg)"
                url={iconAccount}
                alt="icon"
              />
            ) : null}
          </div>
          <div
            className="flex justify-center items-center text-font-xxs font-normal wrap-break-word"
            style={{
              color:
                isDisabled && disabledTextColor
                  ? disabledTextColor
                  : enabledTextColor,
            }}
          >
            {btnTextAccount}
          </div>
        </div>
      ) : (
        <div className="flex flex-col items-center gap-gap-button-s">
          {icon ? (
            <SvgComponent
              color={imgColor}
              height="var(--icon-lg)"
              width="var(--icon-lg)"
              url={icon}
              alt="icon"
            />
          ) : null}
          <div
            className="flex justify-center items-center text-font-xxs font-normal wrap-break-word"
            style={{
              color:
                isDisabled && disabledTextColor
                  ? disabledTextColor
                  : enabledTextColor,
            }}
          >
            {btnText}
          </div>
        </div>
      )}
    </button>
  );
};

export default PositiveNegativeButton;
